import React from 'react';
import { Widget } from './components';

const LockDeviceType = settings => <Widget {...settings} />;

export default LockDeviceType;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/LockDeviceType/LockDeviceType.js